// import React, { useContext, useState } from 'react'
// import Title from '../components/Title'
// import CartTotal from '../components/CartTotal'
// import { assets } from '../assets/assets'
// import { ShopContext } from '../context/ShopContext'
// import axios from 'axios'
// import { toast } from 'react-toastify'
// import { Helmet } from 'react-helmet';

// const PlaceOrder = () => {

//     const [method, setMethod] = useState('cod');
//     const { navigate, backendUrl, token, cartItems, setCartItems, getCartAmount, delivery_fee, products } = useContext(ShopContext);
//     const [formData, setFormData] = useState({
//         firstName: '',
//         lastName: '',
//         email: '',
//         street: '',
//         city: '',
//         state: '',
//         zipcode: '',
//         country: '',
//         phone: ''
//     })

//     const onChangeHandler = (event) => {
//         const name = event.target.name
//         const value = event.target.value
//         setFormData(data => ({ ...data, [name]: value }))
//     }

//     const initPay = (order) => {
//         const options = {
//             key: import.meta.env.VITE_RAZORPAY_KEY_ID,
//             amount: order.amount,
//             currency: order.currency,
//             name:'Order Payment',
//             description:'Order Payment',
//             order_id: order.id,
//             receipt: order.receipt,
//             handler: async (response) => {
//                 console.log(response)
//                 try {
                    
//                     const { data } = await axios.post(backendUrl + '/api/order/verifyRazorpay',response,{headers:{token}})
//                     if (data.success) {
//                         navigate('/orders')
//                         setCartItems({})
//                     }
//                 } catch (error) {
//                     console.log(error)
//                     toast.error(error)
//                 }
//             }
//         }
//         const rzp = new window.Razorpay(options)
//         rzp.open()
//     }

//     const onSubmitHandler = async (event) => {
//         event.preventDefault()
//         try {

//             let orderItems = []

//             for (const items in cartItems) {
//                 for (const item in cartItems[items]) {
//                     if (cartItems[items][item] > 0) {
//                         const itemInfo = structuredClone(products.find(product => product._id === items))
//                         if (itemInfo) {
//                             itemInfo.size = item
//                             itemInfo.quantity = cartItems[items][item]
//                             orderItems.push(itemInfo)
//                         }
//                     }
//                 }
//             }

//             let orderData = {
//                 address: formData,
//                 items: orderItems,
//                 amount: getCartAmount() + delivery_fee
//             }
            

//             switch (method) {

//                 // API Calls for COD
//                 case 'cod':
//                     const response = await axios.post(backendUrl + '/api/order/place',orderData,{headers:{token}})
//                     if (response.data.success) {
//                         setCartItems({})
//                         navigate('/orders')
//                     } else {
//                         toast.error(response.data.message)
//                     }
//                     break;

//                 case 'stripe':
//                     const responseStripe = await axios.post(backendUrl + '/api/order/stripe',orderData,{headers:{token}})
//                     if (responseStripe.data.success) {
//                         const {session_url} = responseStripe.data
//                         window.location.replace(session_url)
//                     } else {
//                         toast.error(responseStripe.data.message)
//                     }
//                     break;

//                 case 'razorpay':

//                     const responseRazorpay = await axios.post(backendUrl + '/api/order/razorpay', orderData, {headers:{token}})
//                     if (responseRazorpay.data.success) {
//                         initPay(responseRazorpay.data.order)
//                     }

//                     break;

//                 default:
//                     break;
//             }


//         } catch (error) {
//             console.log(error)
//             toast.error(error.message)
//         }
//     }



//     // Generate dynamic keywords based on cart items
//     const generateKeywords = () => {
//         const itemNames = Object.keys(cartItems).map(itemId => {
//             const product = products.find(product => product._id === itemId);
//             return product ? product.name : '';
//         });
//         return itemNames.join(', ') + ', online shopping, e-commerce, place order';
//     }

//     return (
//         <>

//         <Helmet>
//         <title>Place Order - Online Shopping</title>
//         <meta name="description" content="Place your order for mobile accessories and gadgets. Choose from multiple payment options including COD, Razorpay, and Stripe." />
//         <meta name="keywords" content={generateKeywords()} />
//        </Helmet>
//         <form onSubmit={onSubmitHandler} className='flex flex-col sm:flex-row justify-between gap-4 pt-5 sm:pt-14 min-h-[80vh] mt-10 ml-4 mr-4'>
//             {/* ------------- Left Side ---------------- */}
//             <div className='flex flex-col gap-4 w-full sm:max-w-[480px]'>

//                 <div className='text-xl sm:text-2xl my-3'>
//                     <Title text1={'DELIVERY'} text2={'INFORMATION'} />
//                 </div>
//                 <div className='flex gap-3'>
//                     <input required onChange={onChangeHandler} name='firstName' value={formData.firstName} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='First name' />
//                     <input required onChange={onChangeHandler} name='lastName' value={formData.lastName} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='Last name' />
//                 </div>
//                 <input required onChange={onChangeHandler} name='email' value={formData.email} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="email" placeholder='Email address' />
//                 <input required onChange={onChangeHandler} name='street' value={formData.street} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='Street' />
//                 <div className='flex gap-3'>
//                     <input required onChange={onChangeHandler} name='city' value={formData.city} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='City' />
//                     <input onChange={onChangeHandler} name='state' value={formData.state} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='State' />
//                 </div>
//                 <div className='flex gap-3'>
//                     <input required onChange={onChangeHandler} name='zipcode' value={formData.zipcode} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="number" placeholder='Zipcode' />
//                     <input required onChange={onChangeHandler} name='country' value={formData.country} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='Country' />
//                 </div>
//                 <input required onChange={onChangeHandler} name='phone' value={formData.phone} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="number" placeholder='Phone' />
//             </div>

//             {/* ------------- Right Side ------------------ */}
//             <div className='mt-8 mr-10'>

//                 <div className='mt-8 min-w-80'>
//                     <CartTotal />
//                 </div>

//                 <div className='mt-12'>
//                     <Title text1={'PAYMENT'} text2={'METHOD'} />
//                     {/* --------------- Payment Method Selection ------------- */}
//                     <div className='flex gap-3 flex-col lg:flex-row'>
//                         {/* <div onClick={() => setMethod('stripe')} className='flex items-center gap-3 border p-2 px-3 cursor-pointer'>
//                             <p className={`min-w-3.5 h-3.5 border rounded-full ${method === 'stripe' ? 'bg-green-400' : ''}`}></p>
//                             <img className='h-5 mx-4' src={assets.stripe_logo} alt="" />
//                         </div> */}
//                         <div onClick={() => setMethod('razorpay')} className='flex items-center gap-3 border p-2 px-3 cursor-pointer'>
//                             <p className={`min-w-3.5 h-3.5 border rounded-full ${method === 'razorpay' ? 'bg-green-400' : ''}`}></p>
//                             <img className='h-5 mx-4' src={assets.razorpay_logo} alt="" />
//                         </div>
//                         <div onClick={() => setMethod('cod')} className='flex items-center gap-3 border p-2 px-3 cursor-pointer'>
//                             <p className={`min-w-3.5 h-3.5 border rounded-full ${method === 'cod' ? 'bg-green-400' : ''}`}></p>
//                             <p className='text-gray-500 text-sm font-medium mx-4'>CASH ON DELIVERY</p>
//                         </div>
//                     </div>

//                     <div className='w-full text-end mt-8'>
//                         <button type='submit' className='bg-black text-white px-16 py-3 text-sm'>PLACE ORDER</button>
//                     </div>
//                 </div>
//             </div>
//         </form>

//         </>
//     )
// }

// export default PlaceOrder
















import React, { useContext, useState ,useEffect} from 'react'
import Title from '../components/Title'
import CartTotal from '../components/CartTotal'
import { assets } from '../assets/assets'
import { ShopContext } from '../context/ShopContext'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet';

const PlaceOrder = () => {
     useEffect(() => {
      const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
      axios.post(`${backendUrl}/api/analytics/visit`, { page: "Place Order" })
        .then(res => console.log(" visit recorded:", res.data))
        .catch(err => console.error("Analytics error:", err));
    }, []);
    const [method, setMethod] = useState('cod');
    const { navigate, backendUrl, token, cartItems, setCartItems, getCartAmount, delivery_fee, products } = useContext(ShopContext);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        street: '',
        city: '',
        state: '',
        zipcode: '',
        country: '',
        phone: ''
    });
    const [discount, setDiscount] = useState(0); // Store discount amount

    const onChangeHandler = (event) => {
        const name = event.target.name
        const value = event.target.value
        setFormData(data => ({ ...data, [name]: value }))
    }

    const initPay = (order) => {
        const options = {
            key: import.meta.env.VITE_RAZORPAY_KEY_ID,
            amount: order.amount,
            currency: order.currency,
            name:'Order Payment',
            description:'Order Payment',
            order_id: order.id,
            receipt: order.receipt,
            handler: async (response) => {
                console.log(response)
                try {
                    const { data } = await axios.post(backendUrl + '/api/order/verifyRazorpay', response, { headers: { token } })
                    if (data.success) {
                        navigate('/orders')
                        setCartItems({})
                    }
                } catch (error) {
                    console.log(error)
                    toast.error(error)
                }
            }
        }
        const rzp = new window.Razorpay(options)
        rzp.open()
    }
    
    const initCashfree = async (orderToken) => {
    const cashfree = new window.Cashfree({
        mode: import.meta.env.VITE_CASHFREE_ENV  // 'sandbox' or 'production'
    });

    let checkoutOptions = {
        paymentSessionId: orderToken,
        redirectTarget: "_self"
    };

    cashfree.checkout(checkoutOptions)
        .then((result) => {
            console.log("Payment Success:", result);
            navigate("/orders");
            setCartItems({});
        })
        .catch((error) => {
            console.error("Cashfree Error:", error);
            toast.error("Payment failed");
        });
};

    // const onSubmitHandler = async (event) => {
    //     event.preventDefault();
    //     try {
    //         let orderItems = [];
    
    //         for (const items in cartItems) {
    //             for (const item in cartItems[items]) {
    //                 for (const color in cartItems[items][item]) {
    //                     if (cartItems[items][item][color] > 0) {
    //                         const itemInfo = structuredClone(
    //                             products.find((product) => product._id === items)
    //                         );
    //                         if (itemInfo) {
    //                             itemInfo.size = item;
    //                             itemInfo.color = color;
    //                             itemInfo.quantity = cartItems[items][item][color];
    //                             orderItems.push(itemInfo);
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    
    //         let orderData = {
    //             address: formData,
    //             items: orderItems,
    //             amount: getCartAmount() + delivery_fee - discount, // Apply discount here
    //         };
    
    //         switch (method) {
    //             case "cod":
    //                 const response = await axios.post(
    //                     backendUrl + "/api/order/place",
    //                     orderData,
    //                     { headers: { token } }
    //                 );
    //                 if (response.data.success) {
    //                     setCartItems({});
    //                     navigate("/orders");
    //                 } else {
    //                     toast.error(response.data.message);
    //                 }
    //                 break;
    
    //             case "stripe":
    //                 const responseStripe = await axios.post(
    //                     backendUrl + "/api/order/stripe",
    //                     orderData,
    //                     { headers: { token } }
    //                 );
    //                 if (responseStripe.data.success) {
    //                     const { session_url } = responseStripe.data;
    //                     window.location.replace(session_url);
    //                 } else {
    //                     toast.error(responseStripe.data.message);
    //                 }
    //                 break;
    
    //             case "razorpay":
    //                 const responseRazorpay = await axios.post(
    //                     backendUrl + "/api/order/razorpay",
    //                     orderData,
    //                     { headers: { token } }
    //                 );
    //                 if (responseRazorpay.data.success) {
    //                     initPay(responseRazorpay.data.order);
    //                 }
    //                 break;
    
    //             default:
    //                 break;
    //         }
    //     } catch (error) {
    //         console.log(error);
    //         toast.error(error.message);
    //     }
    // };

    const onSubmitHandler = async (event) => {
        event.preventDefault();
        try {
            let orderItems = [];
    
            for (const items in cartItems) {
                for (const item in cartItems[items]) {
                    for (const color in cartItems[items][item]) {
                        if (cartItems[items][item][color] > 0) {
                            const itemInfo = structuredClone(
                                products.find((product) => product._id === items)
                            );
                            if (itemInfo) {
                                itemInfo.size = item;
                                itemInfo.color = color;
                                itemInfo.quantity = cartItems[items][item][color];
                                orderItems.push(itemInfo);
                            }
                        }
                    }
                }
            }
    
            // Get total amount and discount
            const { totalAmount, discountAmount } = getCartAmount();
            let finalAmount = totalAmount + delivery_fee - discountAmount;
    
            let orderData = {
                address: formData,
                items: orderItems,
                amount: finalAmount,
            };
    
            switch (method) {
                case "cod":
                    const response = await axios.post(
                        backendUrl + "/api/order/place",
                        orderData,
                        { headers: { token } }
                    );
                    if (response.data.success) {
                        setCartItems({});
                        navigate("/orders");
                    } else {
                        toast.error(response.data.message);
                    }
                    break;
    
                case "stripe":
                    const responseStripe = await axios.post(
                        backendUrl + "/api/order/stripe",
                        orderData,
                        { headers: { token } }
                    );
                    if (responseStripe.data.success) {
                        const { session_url } = responseStripe.data;
                        window.location.replace(session_url);
                    } else {
                        toast.error(responseStripe.data.message);
                    }
                    break;
    
                case "razorpay":
                    const responseRazorpay = await axios.post(
                        backendUrl + "/api/order/razorpay",
                        orderData,
                        { headers: { token } }
                    );
                    if (responseRazorpay.data.success) {
                        initPay(responseRazorpay.data.order);
                    }
                    break;
                case "cashfree":
                    const responseCashfree = await axios.post(
                        backendUrl + "/api/order/cashfree",
                        orderData,
                        { headers: { token } }
                    );

    if (responseCashfree.data.success) {
        initCashfree(responseCashfree.data.orderToken);
    } else {
        toast.error(responseCashfree.data.message);
    }
    break;
                default:
                    break;
            }
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    };
    

    // Generate dynamic keywords based on cart items
    const generateKeywords = () => {
        const itemNames = Object.keys(cartItems).map(itemId => {
            const product = products.find(product => product._id === itemId);
            return product ? product.name : '';
        });
        return itemNames.join(', ') + ', online shopping, e-commerce, place order';
    }

    return (
        <>

        <Helmet>
        <title>Place Order - Online Shopping</title>
        <meta name="description" content="Place your order for mobile accessories and gadgets. Choose from multiple payment options including COD, Razorpay, and Stripe." />
        <meta name="keywords" content={generateKeywords()} />
       </Helmet>
        <form onSubmit={onSubmitHandler} className='flex flex-col sm:flex-row justify-between gap-4 pt-5 sm:pt-14 min-h-[80vh] mt-10 ml-4 mr-4'>
            {/* ------------- Left Side ---------------- */}
            <div className='flex flex-col gap-4 w-full sm:max-w-[480px]'>

                <div className='text-xl sm:text-2xl my-3'>
                    <Title text1={'DELIVERY'} text2={'INFORMATION'} />
                </div>
                <div className='flex gap-3'>
                    <input required onChange={onChangeHandler} name='firstName' value={formData.firstName} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='First name' />
                    <input required onChange={onChangeHandler} name='lastName' value={formData.lastName} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='Last name' />
                </div>
                <input required onChange={onChangeHandler} name='email' value={formData.email} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="email" placeholder='Email address' />
                <input required onChange={onChangeHandler} name='street' value={formData.street} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='Street' />
                <div className='flex gap-3'>
                    <input required onChange={onChangeHandler} name='city' value={formData.city} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='City' />
                    <input onChange={onChangeHandler} name='state' value={formData.state} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='State' />
                </div>
                <div className='flex gap-3'>
                    <input required onChange={onChangeHandler} name='zipcode' value={formData.zipcode} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="number" placeholder='Zipcode' />
                    <input required onChange={onChangeHandler} name='country' value={formData.country} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="text" placeholder='Country' />
                </div>
                <input required onChange={onChangeHandler} name='phone' value={formData.phone} className='border border-gray-300 rounded py-1.5 px-3.5 w-full' type="number" placeholder='Phone' />
            </div>

            {/* ------------- Right Side ------------------ */}
            <div className='mt-8 mr-10'>

                <div className='mt-8 min-w-80'>
                    <CartTotal />
                </div>

                <div className='mt-12'>
                    <Title text1={'PAYMENT'} text2={'METHOD'} />
                    {/* --------------- Payment Method Selection ------------- */}
                    <div className='flex gap-3 flex-col lg:flex-row'>
                        {/* <div onClick={() => setMethod('stripe')} className='flex items-center gap-3 border p-2 px-3 cursor-pointer'>
                            <p className={`min-w-3.5 h-3.5 border rounded-full ${method === 'stripe' ? 'bg-green-400' : ''}`}></p>
                            <img className='h-5 mx-4' src={assets.stripe_logo} alt="" />
                        </div> */}
                        <div onClick={() => setMethod('razorpay')} className='flex items-center gap-3 border p-2 px-3 cursor-pointer'>
                            <p className={`min-w-3.5 h-3.5 border rounded-full ${method === 'razorpay' ? 'bg-green-400' : ''}`}></p>
                            <img className='h-5 mx-4' src={assets.razorpay_logo} alt="" />
                        </div>
                        {/* <div onClick={() => setMethod('cashfree')} className='flex items-center gap-3 border p-2 px-3 cursor-pointer'>
                            <p className={`min-w-3.5 h-3.5 border rounded-full ${method === 'cashfree' ? 'bg-green-400' : ''}`}></p>
                            <img className='h-5 mx-4' src={assets.cashfree_logo} alt="Cashfree" />
                        </div> */}
                        <div onClick={() => setMethod('cod')} className='flex items-center gap-3 border p-2 px-3 cursor-pointer'>
                            <p className={`min-w-3.5 h-3.5 border rounded-full ${method === 'cod' ? 'bg-green-400' : ''}`}></p>
                            <p className='text-gray-500 text-sm font-medium mx-4'>CASH ON DELIVERY</p>
                        </div>
                    </div>

                    <div className='w-full text-end mt-8'>
                        <button type='submit' className='bg-[#FF4902] text-white px-16 py-3 text-sm'>PLACE ORDER</button>
                    </div>
                </div>
            </div>
        </form>

        </>
    )
}

export default PlaceOrder

